import hamburger from './HamburgerMenu.svg'
import house from './House.png'
import React, {Link} from 'react';
import {OutboundLink} from 'react-ga'
import ReactGA from 'react-ga4';

const styles = {
  voterContainer: {
    alignItems: 'stretch',
    flex: 1,
    paddingLeft: '25%',
    paddingRight: '25%',
    backgroundColor: '#CFCFCF',
    paddingTop: '1%',
    paddingBottom: '3%'
  },
  voterView: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    margin: 20
  },
  menuIcon: {
    width: '80px',
    height: '80px',
    position: 'absolute',
    top: 0,
    right: 0,
    margin: 20
  },
  houseImage: {
    height: '300px',
    width: '300px',
    marginTop: '100px'
  },
  headline: {
    textShadow: '3px 3px 3px #ccc'
  }
}

function trackLink(eventName) {
    ReactGA.event({
    category: eventName,
    label: eventName,
    action: eventName
  })
}

function VoterResources(props) {
  return (
    <div style={styles.voterContainer}>
      <div style={styles.voterView}>
        <a href='/menu'>
          <img src={hamburger} style={styles.menuIcon} />
        </a>
        <img src={house} style={styles.houseImage} />
        <h1 style={styles.headline}>
          Voter Resources
        </h1>
        <h3>
          The general election is Tuesday, November 8th
        </h3>
        <h3>
          Deadline to register to vote is October 24th
        </h3>
        <h3>
          Deadline to request an absentee or mail-in ballot is November 1
        </h3>
        <p>
          If you have any questions or need assistance, you can call 1-877-VOTESPA (1-877-868-3772)
        </p>
        <p style={{ fontWeight: 800 }}>
          If you need to register to vote, you can do so by:
        </p>
        <ul>
          <li>
            <a
              onClick={trackLink("regiser online")}
              href="https://www.pavoterservices.pa.gov/pages/VoterRegistrationApplication.aspx"
            >
              Registering online:
            </a>
            It's fast! It's easy! No printer required! ()
          </li>
          <li>
            <a onClick={trackLink("voter registration")} href="https://www.pavoterservices.pa.gov/pages/VoterRegistrationApplication.aspx">
              Print the voter registration
            </a>
            form and deliver it in-person to the County Elections Office at 542 Forbes Avenue, Room 312, Pittsburgh PA 15219
          </li>
        </ul>
        <p>
          If you are a member of the military or live overseas, there are
          <a onClick={trackLink("military voters")} href="https://www.alleghenycounty.us/elections/primary-military-and-overseas-voters.aspx">
            different options for how you can register and vote.
          </a>
          If you are already registered to vote, there are a few different ways you can cast your ballot!
        </p>
        <p style={{ fontWeight: 800 }}>
          Mail-In Ballot
        </p>
        <ul>
          <li>
            Until November 1st, you can request an absentee or mail-in ballot.
          </li>
          <li>
            Mail-in ballots can be returned via the U.S. Mail OR dropped off directly at
            the Allegheny County Board of Elections at the City-County Building (542 Forbes
            Avenue, Room 312, Pittsburgh, PA 15219). The mail can take awhile to process, so
            if it is close to Election Day on November 8th, the best way to return your mail-in
            ballot is to drop it off at the Board of Elections.
          </li>
          <li>
            PLEASE REMEMBER TO SIGN AND DATE YOUR BALLOT! If your ballot doesn't have a date
            written on it, it will most likely be disqualified. Don’t forget all of the appropriate
            envelopes too!
          </li>
          <li>
            If you need help filling in your mail-in ballot, you can take it to the Board
            of Elections and they can help you. Be sure to bring all of the envelopes with you.
          </li>
        </ul>
        <p>
          What happens if I requested a mail-in ballot, but didn't get to mail it and I can't make it downtown to return it?
        </p>
        <p>
          Things happen and we all get busy. You may find yourself with your mail-in ballot in hand,
          but it's too late to mail it and you can't make it downtown to drop it off. Also, there is
          a chance Allegheny County may not send your mail-in ballot early enough for you to have time
          to either mail it back or drop it off, but don’t worry! You can still vote regularly at your
          assigned local polling place on election day!
        </p>
        <p>
          Do not fill in your ballot. Leave it blank. On November 8th, take all of the materials
          you received (the ballot itself plus both of the envelopes) to your regular assigned polling
          location. When you get there, tell them you want to surrender your mail-in ballot and vote
          regularly. The judge of elections should have a form for you to fill out and sign verifying
          you </p><p style={{ fontWeight: 800, margin: 0 }}>surrendered your ballot.</p>

        <p>
          The poll workers will then sign you in as if you were there to vote the standard way and give
          you a regular ballot. You should not be forced to vote provisionally if you surrender your
          blank ballot and both envelopes! If your polling place tries to give you a provisional ballot,
          do not accept it. Instead, call the Allegheny County Elections office at 412-350-4500.
          They will pick up the phone and help you! They are ready to accept these types of calls
          on election day and can speak with your polling place and inform them of the correct
          procedure. For more information on this, please see “Can I return my voted mail-in or
          absentee ballot at my polling place?”
          <a onClick={trackLink("election FAQs")} href="https://www.vote.pa.gov/Voting-in-PA/Pages/Elections-FAQs.aspx">
            here.
          </a>
        </p>
        <p style={{ fontWeight: 800 }}>
          Over The Counter In-Person Voting Prior To Election Day
        </p>
        <p>
          The Board of Elections will be allowing voters to vote early in-person. To take advantage
          of this service, you must:
        </p>
        <ul>
          <li>Already be registered to vote</li>
          <li>HAVE NOT previously requested a mail-in ballot for the 2022 election</li>
          <li>Be able to travel to the County Office Building downtown</li>
        </ul>
        <p>
          This is a great option for folks who aren't sure they'll be able to make it to the
          polls on Election Day!
        </p>
        <p>
          Over the counter voting is basically requesting and receiving a mail-in ballot in-person.
          When you go, you will have to fill out the form requesting a mail-in ballot. Elections staff
          will then check your application and approve it right there. They will give you a ballot
          and show you to a special area where you will be able to fill it in privately. After
          completing your ballot, you will be able to turn it into election staff and you will
          have officially voted!
        </p>
        <p>
          This service is available Monday through Friday from 8:30 am to 4:30 pm from now until November
          1st. The Elections office will be set up offering this service in the lobby of the County Office
          Building at 542 Forbes Avenue, Pittsburgh, PA 15219
        </p>
        <p style={{ fontWeight: 800 }}>
          Vote in-person at your local polling place on Election Day!
        </p>
        <a onClick={trackLink("polling place")} href="https://www.pavoterservices.pa.gov/Pages/PollingPlaceInfo.aspx">
          Click here to find your local polling place!
        </a>
        <p>
          Want to see who and what is going to be on your ballot, make a voting plan, and more?
          Check out <a onClick={trackLink("ballot ready")} href="https://www.ballotready.org/">BallotReady!</a>
        </p>
      </div>
    </div>
  )
}

export default VoterResources;
